module.exports = __webpack_public_path__ + "static/media/constructive-emotions.bfd169d5.png";